<template>
  <div v-show="isShow" class="noData-pic">
    <p class="noData-text">{{ tips }}</p>
  </div>
</template>
<script>
const existData = function (data) {
  if (data === this.constant.ARRAY_CLEAN) {
    return true;
  }

  if (typeof data === 'boolean') {
    return data
  } else if (data instanceof Array) {
    return data.length !== 0
  } else {
    return !!data
  }
}
export default {
  props: {
    condition: {
      require: true
    },
    tips: {
      type: String,
      default: function () {
        return '没有找到相关数据'
      }
    }
  },
  data () {
    return {
      isShow: false,
      origin: []
    }
  },
  watch: {
    condition (val) {
      this.isShow = !existData.call(this, val)
    }
  }
}
</script>
<style lang="scss">
.noData-pic {
  background: url(../../static/img/yemian-bg.png) no-repeat top center;
  background-size: 111px 111px;
  margin: 2rem auto 0 auto;
  width: 100%;
}
.noData-text {
  font-size: 18px;
  /*font-weight: bold;*/
  text-align: center;
  height: 2rem;
  line-height: 2rem;
  padding-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// NoRecord.vue?bf6752da